<template>
  <v-sheet>
    <div v-if="streamerData" class="d-flex justify-center">
      <v-row style="max-width: 800px;">
        <v-col>
          <v-avatar :image="streamerData.user.profile_pic ?? Utils.getImgUrl('user_profile_pic.png')" size="96"/>
          <span class="font-weight-bold ml-5" style="font-size: 24px;">{{streamerData.user.username}}</span>
          <v-icon v-if="streamerData?.verified" size="24" class="ml-1 mb-2">
            <img :src="utils.getBadgeUrl('verified')" alt="verified">
          </v-icon>
        </v-col>
        <v-col class="mt-3">
          <span>{{ streamerData.user.bio }}</span>
          <kicklet-gradient-button
              class="mt-3"
              :variant="utils.buttonVariant"
              color="primary"
              :text="$t('user-lookup.buttons.visit-on-kick')"
              :zoom-on-hover="true"
              @click="openKickPage"
          />
        </v-col>
      </v-row>
    </div>
    <p v-else-if="error">
      {{ $t('user-lookup.user-not-found') }}
    </p>
  </v-sheet>
</template>
<script setup>
import { ref } from 'vue';
import { Utils } from '@/modules/utils';
import KickletGradientButton from '@/components/custom/kicklet/KickletGradientButton.vue';

const error = ref(null);

const props = defineProps({
  streamerData: Object,
});

function openKickPage () {
  const url = 'http://kick.com/' + props.streamerData.slug;
  window.open(url, '_blank');
}
</script>

<style scoped>
.name-text {
  font-size: 28px;
}
</style>
